import React from 'react';
import Card from '../../../core/layout/Card';
import PlacementTestReportStudentsListContainer from './PlacementTestReportStudentsListContainer';
import PlacementTestReportStudentsListFilterContainer from './PlacementTestReportStudentsListFilterContainer';
import PlacementTestReportTestDialogContainer from './PlacementTestReportTestDialogContainer';

export default function PlacementTestReportStudentsTab() {
  return (
    <Card title={<PlacementTestReportStudentsListFilterContainer />}>
      <PlacementTestReportStudentsListContainer />
      <PlacementTestReportTestDialogContainer />
    </Card>
  );
}
